<div style="display:flex;flex-direction: column;align-items: center;" [ngStyle]="{'margin':margin}">
  <img *ngIf="image" [src]="image" style="margin-bottom:16px"
    [ngStyle]="{width: imageWidth + 'px', height: imageHeight + 'px'}">
  <div style="font-size:16px;font-weight:500;color:#A6A8B8">{{ label }}</div>
</div>